<template>
  <div class="tours">
    <div class="top">
      <div class="title">Success Cases</div>
    </div>
    <div class="nav">
      <div class="nav-con">
        <div class="list" @click="getListFn(item, index)" :class="currentNav == index ? 'active' : ''"
          v-for="(item, index) in typeList" :key="index">
          {{ item.nav_title_en }}
        </div>
      </div>
    </div>
    <div class="lists" v-loading="loading">
      <div class="list" @click="toDetail(item)" v-for="item in list">
        <div class="img">
          <img :src="item.image_url" alt="">
        </div>
        <div class="name u-line-3">{{ item.news_title_en }}</div>
      </div>
    </div>
    <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize3" background border
      layout="prev, pager, next" :total="total" @current-change="handleCurrentChange" />
  </div>
</template>

<script>

export default {
  data() {
    return {
      loading: false,
      total: 0,
      currentPage: 1,
      pageSize3: 8,
      typeList: [],
      list: [],
      currentNav: 0, 
    }
  },
  mounted() {
    this.getNewGoodTypeFn()
  },
  methods: {
    getListFn(item, index) {
      this.currentNav = index;
      this.getNewGoodFn()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      console.log(`current page: ${val}`);
    },
    toDetail(item) {
      this.$router.push('/en/goodNewsDetail?img=' + item.image_url + '&name=' + item.news_title_en)
    },
    getNewGoodFn() {
      //获取下签喜报
      this.loading = true
      this.$http.nav_list_view({
        model_type_id: this.typeList[this.currentNav].nav_id,
        page: this.currentPage,
        pagesize: this.pageSize3,
      }).then(res => {
        console.log(res)
        this.list = res.data;
        this.total = res.count
      }).finally(() => {
        this.loading = false
      })
    },
    getNewGoodTypeFn() {
      //获取下签喜报
      this.$http.video_nav_list({
        type_id: 854,
      }).then(res => {
        this.typeList = res.data;
        this.currentNav = 0;
        this.getNewGoodFn();
      })
    }
  }
}
</script>

<style lang="less" scoped>
.tours {
  padding-bottom: 180px;
  background-color: #f1f1f1;

  .el-pagination {
    margin: 50px auto 120px;
    display: flex;
    justify-self: center;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #ec0b29;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #ec0b29;
  }

  .lists {
    display: flex;
    max-width: 1200px;
    margin: 0 auto;
    flex-wrap: wrap;

    .list {
      width: calc(25% - 30px);
      margin: 40px 10px 0;
      background-color: #fff;
      border-radius: 6px;
      overflow: hidden;
      transition: .3s all;
      padding: 10px;
      box-sizing: border-box;
      box-shadow: 0 0 10px #ccc;
      cursor: pointer;
      transition: .3s all;

      .img {
        width: 100%;
        height: 360px;
        overflow: hidden;

        img {
          width: 100%;
          height: auto;
          transition: .3s all;
        }
      }

      &:hover {
        transform: scale(1.1);

        .name {
          color: #ae0000;
        }
      }

      .name {
        transition: .3s all;
        font-size: 17px;
        color: #333;
      }
    }
  }

  .nav {
    width: 100%;
    padding: 30px 0;
    background-color: #ae0000;

    .nav-con {
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      border-radius: 6px;

      .list {
        flex-shrink: 0;
        font-size: 16px;
        height: 45px;
        padding: 0 20px;
        margin: 0 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
        justify-content: center;
        transition: .3s all;
        color: #fff;
        border-radius: 6px;
        position: relative;

        &::after {
          content: '';
          right: -20px;
          height: 30px;
          width: 1px;
          background-color: #fff;
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
        }
      }

      .list:nth-last-of-type(1)::after {
        content: none;
      }

      .list:hover,
      .list.active {
        color: #ae0000;
        background-color: #fff;
      }

    }
  }

  .top {
    width: 100vw;
    height: 340px;
    position: relative;
    overflow: hidden;
    background-image: url('../../assets/imgs/study_in_australia.jpg');
    background-size: auto 100%;
    transition: .3s all;
    background-position: center;

    .title {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 60px;
      font-weight: 600;
      letter-spacing: 2px;
      color: #ae0000;
      text-shadow: 3px 3px 5px #fff;
    }



    img {
      width: 100%;
      object-fit: cover;
      height: 100%;
      transition: .3s all;
    }

    &:hover {
      background-size: auto 110%;

      img {
        transform: scale(1.1);
      }
    }
  }


}

@media (max-width: 899px) {
  .tours {
    padding-bottom: 80px;

    .top {
      height: 200px;

      .title {
        font-size: 30px;
        text-align: center;
        padding: 0 20px;
        box-sizing: border-box;
      }
    }

    .nav {
      padding: 15px 0;

      .nav-con {
        padding: 0 10px;
        box-sizing: border-box;

        .list {
          font-size: 14px;
          height: 35px;
          margin: 5px 5px;
          padding: 0 15px;
        }

        .list::after {
          right: -10px;
          height: 20px;
        }

        .list:nth-last-of-type(1)::after {
          content: none;
        }
      }
    }

    .lists {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      padding: 0 15px;
      box-sizing: border-box;

      .list {
        width: calc(50% - 10px);
        margin: 20px 5px 0;

        .img {
          height: 200px;
        }

        .name {
          font-size: 14px;
          padding: 10px 5px;
          box-sizing: border-box;
        }

        &:hover {
          transform: scale(1.05);
        }
      }
    }

    .el-pagination {
      margin: 30px auto 60px;
    }
  }
}

/* 响应式适配：小屏幕设备 */
@media (max-width: 480px) {
  .tours {
    padding-bottom: 60px;

    .top {
      height: 160px;

      .title {
        font-size: 24px;
        padding: 0 15px;
      }
    }

    .nav {
      padding: 10px 0;

      .nav-con {
        .list {
          font-size: 12px;
          height: 30px;
          margin: 3px 3px;
          padding: 0 10px;
        }

        .list::after {
          right: -5px;
          height: 15px;
        }
      }
    }

    .lists {
      .list {
        width: 100%;
        margin: 15px 0 0;

        .img {
          height: 180px;
        }

        .name {
          font-size: 13px;
          padding: 8px 5px;
        }
      }
    }

    .el-pagination {
      margin: 20px auto 50px;

      /deep/.el-pagination__sizes,
      /deep/.el-pagination__total {
        display: none;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/en/goodNews.vue